<template>
  <div>
    <div>
      <div style="float: left;">
        <h1> 用户组列表</h1>
      </div>

      <div style="float: right;">
        <el-button @click="initAdd" icon="el-icon-plus" type="primary">添加新用户组</el-button>
      </div>
    </div>


    <el-table
        :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">


      <el-table-column
          label="用户组ID"
          prop="id"
          width="150">
      </el-table-column>

      <el-table-column
          label="用户组名"
          prop="name"
          width="150">
      </el-table-column>

      <el-table-column
          label="用户组创建者"
          prop="owner"
          width="150">
      </el-table-column>

      <el-table-column
          label="用户组成员"
          width="150">

        <template slot-scope="scope">
          <el-tag :key="username" class="user" v-for="username in scope.row.userNames">{{ username }}</el-tag>
        </template>

      </el-table-column>

      <el-table-column
          label="用户组创建时间"
          prop="createTime">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="操作">
        <template slot="header" slot-scope="{}">
          <el-input
              placeholder="输入关键字搜索"
              size="mini"
              v-model="search"/>
        </template>
        <template slot-scope="scope">
          <el-button
              @click="initEdit(scope.row,scope.$index)"
              size="mini">编辑
          </el-button>
          <el-button
              @click="deleteUserGroup(scope.row.id,scope.$index)"
              size="mini"
              type="danger">删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-dialog :visible.sync="formVisible" title="用户组信息">
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth" label="用户组id" v-show="inputVisible">
          <el-input :disabled="true" autocomplete="off" v-model="form.id"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="用户组名称" prop="userGroupName">
          <el-input autocomplete="off" v-model="form.name"></el-input>
        </el-form-item>


        <el-form-item :label-width="formLabelWidth" label="用户组成员">
          <el-select multiple placeholder="请选择用户组成员" v-model="form.userIDS">
            <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in allUser">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item :label-width="formLabelWidth" label="用户组创建者" v-show="inputVisible">
          <el-input :disabled="true" autocomplete="off" v-model="form.owner"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="用户组创建时间" v-show="inputVisible">
          <el-input :disabled="true" autocomplete="off" v-model="form.createTime"></el-input>
        </el-form-item>

      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button @click="confirmHandler" type="primary">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<style scoped>
.user {
  margin: 4px;
}

</style>
<script>
import {Apis} from "@/api";

export default {
  data() {
    return {
      tableData: [{
        id: "",
        name: "",
        owner: "",
        userIDS: [],
        userNames: [],
        createTime: "",

      }],
      formLabelWidth: '120px',
      search: "",

      formVisible: false,
      inputVisible: false,
      index: 0,
      allUser: [], //公用的所有用户列表

      form: {
        id: "",
        name: "",
        owner: "",
        userIDS: [],
        userNames: [],
        createTime: "",

      },
    }
  },
  methods: {

    //------------------------------------页面初始化函数--------------------------------------//
    //添加页面 初始化
    initAdd() {
      //隐藏部分输入框
      this.inputVisible = false

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()
    },

    //编辑页面 初始化
    initEdit(row, index) {
      //不再隐藏部分框
      this.inputVisible = true

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()

      //填充数据 复制
      this.form = JSON.parse(JSON.stringify(row))

      // console.log("initEdit")
      // console.log(row,index)

      //得到行号，方便更新成功之后更新列表中的数据
      this.index = index


    },

    //-----------------------------------工具函数----------------------------------------------//
    //重置表单字段
    resetForm() {
      this.form.id = ""
      this.form.name = ""
      this.form.owner = ""
      this.form.createTime = ""


      this.form.userNames = []
      this.form.userIDS = []
    },


    //----------------------------------前端函数----------------------------------------------//
    //弹窗界面确认按钮的处理函数
    async confirmHandler() {
      //保证输入不空
      if (this.form.name === "" || this.form.name === undefined) {
        this.$message.error("用户组名称不能为空");
        return
      }
      //不同情况对应不同接口
      if (this.inputVisible === false) {
        //添加用户组
        await this.addUserGroup()
        // console.log(this.userIDS)

      } else {
        //更新用户组
        await this.updateUserGroup()
      }

      // 隐藏弹窗界面
      this.formVisible = false
    },

    //-----------------------------------后端函数----------------------------------------------//
    //删除用户组
    async deleteUserGroup(userGroupID, index) {
      this.$confirm('此操作将永久删除该用户组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await Apis.UserGroup.deleteUserGroup(userGroupID)
        if (response != null && response.errno === 0) {
          this.$message.success("用户组删除成功!");

          //列表中删除该行
          this.tableData.splice(index, 1)
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //新增用户组
    async addUserGroup() {
      const response = await Apis.UserGroup.addUserGroup(this.form.name, this.form.userIDS)
      let userGroup;
      if (response != null && response.errno === 0) {
        this.$message.success("用户组信息添加成功!");
        userGroup = response.data

        //列表头部新增一行
        this.tableData.unshift({
          id: userGroup.id,
          name: userGroup.name,
          owner: userGroup.owner,

          userNames: userGroup.userNames,

          createTime: userGroup.createTime,
        })
      }
    },

    //更新用户组
    async updateUserGroup() {
      const response = await Apis.UserGroup.updateUserGroup(this.form.id, this.form.name, this.form.userIDS)
      // console.log(response)
      if (response != null && response.errno === 0) {
        this.$message.success("用户组更新成功");

        //更新form的userNames
        this.form.userNames = []
        for (let i = 0; i < this.form.userIDS.length; i++) {
          const userID = this.form.userIDS[i]
          for (let j = 0; j < this.allUser.length; j++) {
            if (userID === this.allUser[j].id) {
              this.form.userNames.push(this.allUser[j].name)
            }
          }
        }

        //先删除元素，然后将元素插入头部
        this.tableData.splice(this.index, 1)
        this.tableData.unshift(JSON.parse(JSON.stringify(this.form)))

      }
    },

  },
  created: async function () {
    //初始化主页面
    this.tableData = []

    //获取所有用户组的基础数据
    const response = await Apis.UserGroup.getUserGroups();
    //填充用户组数据
    this.tableData = response.data || []

    //填充用户列表数据
    const r = await Apis.User.getAllUser()
    this.allUser = r.data || []
  }
}

</script>



